// src/pages/SettingPage/index.js

import React from 'react';
import { Typography, Tabs } from 'antd';
import { UserOutlined, SafetyCertificateOutlined, CheckSquareOutlined, TeamOutlined } from '@ant-design/icons';

// Import các component con cho từng tab
import StudentManagementTab from './tabs/StudentManagementTab';
import RoleManagementTab from './tabs/RoleManagementTab';
import PermissionManagementTab from './tabs/PermissionManagementTab';
import TeacherManagementTab from './tabs/TeacherManagementTab'; // 1. Import tab mới

const { Title } = Typography;

const SettingPage = () => {
  const tabItems = [
    {
      label: (<span><UserOutlined /> 学生管理</span>),
      key: 'students',
      children: <StudentManagementTab />,
    },
    { // 2. Kích hoạt (bỏ comment) cho tab này
      label: (<span><TeamOutlined /> 職員管理</span>),
      key: 'teachers',
      children: <TeacherManagementTab />,
    },
    {
      label: (<span><SafetyCertificateOutlined /> 役割管理</span>),
      key: 'roles',
      children: <RoleManagementTab />,
    },
    {
      label: (<span><CheckSquareOutlined /> 権限管理</span>),
      key: 'permissions',
      children: <PermissionManagementTab />,
    },
  ];

  return (
    <div>
      <Title level={2}>システム設定</Title>
      <Tabs defaultActiveKey="students" items={tabItems} />
    </div>
  );
};

export default SettingPage;